import axios from '../axios'
//线下
//  const agencyId=1
 //线上
 const agencyId=5
 export default agencyId
// 获取协会排名
export const assoPage = (data) => {
  return axios({
    url:`/match/websiteCityAsso/assoPage/${data.pageNum}/${data.pageSize}/${agencyId}/${data.year}`,
    method: 'GET',
    headers: {
      isToken: false
    },
  })
}
// 获取协会banner数据
export const headerData = () => {
  return axios({
    url: `/match/websiteCityAsso/headerData/${agencyId}`,
    method: 'GET',
    headers: {
      isToken: false
    },
  })
}
// 获取新闻分类
export const websiteMainType = (newId) => {
  return axios({
    url: `/match/websiteMain/type/${newId}`,
    method: 'GET',
    headers: {
      isToken: false
    },
  })
}
// 获取有图新闻详情
export const noticeDetail = (newId) => {
  return axios({
    url: `/match/websiteMain//noticeDetail/${newId}`,
    method: 'GET',
    headers: {
      isToken: false
    },
  })
}
// 获取无图新闻详情
export const findDetailById = (newId) => {
  return axios({
    url: `/match/websiteMain/findDetailById/${newId}`,
    method: 'GET',
    headers: {
      isToken: false
    },
  })
}
// 获取场馆所属类型
export const venueInfoType = () => {
  return axios({
    url: `/venue/manager/info/venueInfoType`,
    method: 'GET',
  })
}
// 获取场馆详情
export const venueDetail = (venueId) => {
  return axios({
    url: `/venue/web/venueDetail/${venueId}`,
    method: 'GET',
  })
}
// 获取场馆配套
export const supportFacilities = () => {
  return axios({
    url: '/venue/manager/info/supportFacilities',
    method: 'GET',
  })
}
// 获取场馆设施
export const fieldFacilities = () => {
  return axios({
    url: '/venue/manager/info/fieldFacilities',
    method: 'GET',
  })
}
// 删除场馆详情的照片
export const deleteVenuePhotos = (photoId) => {
  return axios({
    url: `/venue/manager/venuePhoto/del/${photoId}`,
    method: 'DELETE',
  })
}
// 添加场馆详情的照片
export const addVenuePhotos = (data) => {
  return axios({
    url: '/venue/manager/venuePhoto/add',
    method: 'POST',
    data,
  })
}
// 获取场馆详情的照片
export const venuePhotos = (photoId) => {
  return axios({
    url: `/venue/web/venuePhotos/${photoId}`,
    method: 'GET',
    headers: {
      isToken: false
    },
  })
}
/**
 * 删除提交的场馆
 * @returns {Promise | Promise<unknown>}
 */
export const removeVenue = (id) => {
  return axios({
    url: `/venue/manager/info/remove/${id}`,
    method: 'DELETE',
  })
}
/**
 * 获取提交的场馆
 * @returns {Promise | Promise<unknown>}
 */
export const findOwner = () => {
  return axios({
    url: '/venue/manager/info/findOwner',
    method: 'GET',
  })
}
/**
 * 注册场馆
 * @returns {Promise | Promise<unknown>}
 */
export const registVenue = (data) => {
  return axios({
    url: '/venue/manager/info/registVenue',
    data,
    method: 'POST'
  })
}
/**
 * 用户端直接上传到七牛，获取七牛的token
 * @returns {Promise | Promise<unknown>}
 */
export const fileUpToken = () => {
  return axios({
    url: '/match/file/getUpToken',
    method: 'GET'
  })
}

// 获取场馆列表
export const venuePage = (data) => {
  return axios({
    url: '/venue/web/venuePage',
    method: 'POST',
    data,
    headers: {
      isToken: false
    },
   
  })
}
// 获取场馆的项目类型
export const venueType = (agencyId) => {
  return axios({
    url: `/venue/web/venueType/${agencyId}`,
    method: 'get',
    headers: {
      isToken: false
    }
  })
}
// 查询banner
export const queryBanner = () => {
  return axios({
    url: `/match/websiteMain//queryBanner/${agencyId}`,
    method: 'get',
    headers: {
      isToken: false
    }
  })
}
// 查询首页机构数量
export const getMatchNumbers = () => {
  return axios({
    url: `/match/websiteMain/queryCityTotalData/${agencyId}`,
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

// 查询置顶图片新闻公告 {agencyId}
export const topNotices = () => {
  return axios({
    url: `/match/websiteMain//topNotices/${agencyId}`,
    method: 'get',
    headers: {
      isToken: false
    }
  })
}
// 新闻分类列表 {agencyId}
export const findSeriesGroupList = () => {
  return axios({
    url: `/match/websiteMain/findSeriesGroupList/${agencyId}`,
    method: 'get',
    headers: {
      isToken: false
    }
  })
}

// 按类型查询新闻列表 {agencyId}/{pageNum}/{pageSize}/{typeId}
export const listByType = data => {
  return axios({
    url: `/match/websiteMain/listByType/${agencyId}/` + data.pageNum + '/' + data.pageSize + '/' + data.type,
    method: 'get',
    headers: {
      isToken: false
    }
  })
  // }
}

/*
* 查询机构排行榜
* @returns {Promise | Promise<unknown>}
*/
export const getAgencyRank = data => {
  return axios({
    url: `/match/website/findCityAgencyRankList/${agencyId}/` + data.programId + '/' + data.province + '/' + data.year + '/' + data.name + '/' + data.type + '/' + data.pageNum + '/' + data.pageSize,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}
  
/**
  * 查询运动员排行榜
  * @returns {Promise | Promise<unknown>}
  */
export const getPlayRank = data => {
  return axios({
    url: `/match/website/findCityPlayerRankList/${agencyId}/` + data.programId + '/' + data.province + '/' + data.year + '/' + data.name + '/' + data.pageNum + '/' + data.pageSize,
    method: 'GET',
    headers: {
      isToken: false
    }
  })
}


// WEBPACK FOOTER //
// ./src/comm/http/modules/ddk.js